/* eslint-disable ember/classic-decorator-hooks */
import * as RollOffStepResponse from '../../../step-response/roll-off';
import Circuit from './circuit';
import BigHugeCircuitGroup from './big-huge-circuit-group';
import BaseMain from '../../implementation-common/base-main';
import * as ReverseImplementation from './reverse-implementation';

export default class MultipleFeedbackHighPassMain extends BaseMain {
  bigHugeCircuitGroupModel;
  reverseImplementation;
  algorithm;

  init() {
    this.bigHugeCircuitGroupModel = BigHugeCircuitGroup;
    this.reverseImplementation = ReverseImplementation;
  }

  getStepValues(idealStep, circuit, timeAxis) {
    var k = circuit.c1.value / circuit.c5.value;
    var result = RollOffStepResponse.getActualStepResponse(idealStep, circuit, timeAxis, k);

    // invert step response for Multiple Feedback HPF, b/c it's an inverting configuration
    result = result.map((item) => {
      return item * -1;
    });

    return result;
  }

  createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue) {
    var result = Circuit.create({
      algorithm: this.algorithm,
      stageFp: stageFp,
      gain: gain,
      stageQ: stageQ,
      optimization: optimization,
      initialCapacitorValue: initialCapacitorValue,
    });
    return result;
  }
}
